export default {
  bind(el) {
    el.addEventListener('wheel', event => {
      event.preventDefault()
      el.scrollLeft += event.deltaY
    })
  },
}
